import { apiHelper } from '@/utils/api.helper'

export const productApi = {
  getProductByDealType,
  getProductByCategory,
  addProductToWishlist
}

const PRODUCT = {
  DEAL_LIST: '/page/getdealslist',
  CATEGORY_PRODUCTS: '/page/search',
  ADD_PRODUCT_TO_WISHLIST: '/wishlist/create'
}

function getProductByDealType(obj) {
  let requestBody = {
    params: {
      type: obj.productDealType,
      top_pick_image_id: obj.productTopPickImageId
    }
  }
  return apiHelper(false).get(`${PRODUCT.DEAL_LIST}`, requestBody)
}

function getProductByCategory(obj) {
  let requestBody = {
    params: {
      category: obj.category
    }
  }
  return apiHelper(false).get(`${PRODUCT.CATEGORY_PRODUCTS}`, requestBody)
}

function addProductToWishlist(obj) {
  let requestBody = {
    params: {
      product_id: obj.product_id
    }
  }
  return apiHelper(false).get(`${PRODUCT.ADD_PRODUCT_TO_WISHLIST}`, requestBody)
}
